import { createI18n, WEB_LOCALES } from '@careandkey/shared';

// Back-office + owner portal: en (default), fr, es, ru.
// Initial language from the browser; later overridden by the user's org/profile.
const browserLng = typeof navigator !== 'undefined' ? navigator.language.slice(0, 2) : 'en';

export const i18n = createI18n(WEB_LOCALES, browserLng);
